import React, { useState, useEffect } from "react";
import axios from "axios";
import {ReactComponent as Edit} from '../assets/edit.svg';
import {ReactComponent as Delete} from '../assets/dele.svg'
import {ReactComponent as SearchIcon } from "../assets/serch-icon.svg";
import {ReactComponent as ClIcon} from '../assets/close-icon.svg';
import {ReactComponent as SIcon} from '../assets/save-icon.svg';
import { ReactComponent as Plus} from "../assets/p-icon.svg";

import { ScrollRestoration } from "react-router-dom";



const PaginationTable = ({uId}) => {
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [showIcon, setShowIcon] = useState(true);
  const [ingredients, setIngredients] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [editFrom, setEditForm] = useState(false);
  const [nEIngredient, setNEIngredient] = useState("");
  const [cEIngredient, setCEIngredient] = useState("");
  const [sEIngredient, setSEIngredient] = useState("");
  const [edtIngTyp, setEdtIngTyp] = useState("");
  const [sEIAlco, setSEIAlco] = useState(0);
  const [newIName, setNewIName] = useState("");
  const [newICost, setNewICost] = useState("");
  const [newIStock, setNewIStock] = useState("");
  const [newIAlco, setNewIAlco] = useState(0);
  const [newIngred, setNewIngred] = useState("");
  const [editId, setEditId] = useState(0);

  const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
  const [currentR, setCurrentR] = useState("");
              // newTask
  const [juices, setJuices] = useState(false);
  const [typeD, setTypeD] = useState("");
  const [newSell, setNewSell] = useState("");
  const [ings, setIngs] = useState(true);
  const [newIqtyt, setNewIqtyt] = useState();
  const [img, setImg] = useState("");
  const [macName, setMacName] = useState("");
  const [machines ,setMachines] = useState([]);
  const [macId, setMacId] = useState("");
  const [mId, setMachineId] = useState();
  const [userD, setUserD] = useState(null);
  const [selectedImage, setSelectedImage] = useState("");
  const [imageName, setImageName] = useState("old-1618821015.png");
  const [showDrop, setShowDrop] = useState(false);
  const [selectedImage2, setSelectedImage2] = useState(selectedImage);
  const [recipeMainImages, setRecipeMainImages] = useState([]);
  const [imageUrls, setImageUrls] = useState({});
  const [imageSearch, setImageSearch] = useState("");
  const [volume, setVolume] = useState("");
  const [cstmCost, setCstmCost] = useState("");
  const volumeOptions = [700, 1000, 1500, 3500, 5000];
  useEffect(() => {
      const handleResize = () => {
          setSmallMedia(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    const userId = uId;
  useEffect(() => {
    fetchIngredients();
    fetchRecImages();
    fetchMachines();
  }, [uId, userId]);
  useEffect(() => {
    const userDataString = sessionStorage.getItem('userData');
    if (userDataString) {
        const userData = JSON.parse(userDataString);
        setUserD(userData);
        // Use userData as needed
    }
    // console.log(userDataString);
}, []);
useEffect(() => {
    setMachineId(userD ?.selectedMachineIds);
    setMacName(userD?.selectedName);
    setMacId(userD?.selectedMachineIds[0]);
}, [userD]);
const fetchImage = async (imgname) => {
   
  const res = await axios.get(
    `/api/image-base?image-name=${imgname}`, 
    {
      withCredentials: true,
      responseType: 'blob'
    }
  );

  const imageUrl = URL.createObjectURL(res.data);
  setSelectedImage(imageUrl);
  setSelectedImage2(imageUrl);
};
const fetchImage3 = async (imgname) => {
   
  const res = await axios.get(
    `/api/image-base?image-name=${imgname}`, 
    {
      withCredentials: true,
      responseType: 'blob'
    }
  );

  const imageUrl = URL.createObjectURL(res.data);
  setSelectedImage(imageUrl);
  setSelectedImage2(imageUrl);
};

  const fetchIngredients = async () => { 
    let macId2;
    let userId2;
    const userDataString = sessionStorage.getItem('userData');

    // Check if userData exists in sessionStorage
    if (!userDataString) {
        console.error('No userData found in sessionStorage');
        alert("No user data available")
        return; // Exit the function if userData is not available
    }

    try {
        const userData = JSON.parse(userDataString);

        // Ensure selectedMachineIds exists and has at least one value
        if (userData.selectedMachineIds && userData.selectedMachineIds.length > 0) {
            macId2 = userData.selectedMachineIds[0];
            userId2 = userData.id;
            setUserD(userData); // Update user data state if needed
        } else {
            console.error('No selectedMachineIds found in userData');
            return; // Exit the function if selectedMachineIds is not available
        }

        // Ensure macId is included in the request
         
        const response = await axios.get(`/api/ingredients?userId=${userId2}&macId=${macId2}`, 
          { withCredentials: true }
        );
        // console.log("Ingredients from ingredient table", response.data);
        
        // setIngredients(response.data);
        const sortedIngredients = [...response.data].sort((a, b) =>
          a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
        );

        setIngredients(sortedIngredients);
        setTotalRows(response.data.length);
       // console.log("Fetching ingredients at:", new Date().toLocaleTimeString(), "Response data is ", response.data);
    } catch (error) {
        console.error('Error fetching ingredients:', error);
    }
};
  useEffect(() => {

    const interval = setInterval(() => {
      fetchIngredients();
    }, 15000); // Every 15 seconds

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setShowIcon(e.target.value === '');
  };

  const handleEditClick = (ingredient) => {
    // console.log(ingredient);
    setEdtIngTyp(ingredient.type);
    if(ingredient.type === "ingredient"){
      setTypeD("ingredient");
    }else{
      setTypeD("Juice");
    }
    setEditForm(true);
    const unId = ingredient.unique_id.split("_");
    const id = unId[1];
    setEditId(id);
    setNEIngredient(ingredient.name);
    setCEIngredient(ingredient.cost_ml);
    setSEIngredient(ingredient.stock_level_ml);
    setCstmCost(ingredient.vol_cost);
    setVolume(ingredient.volume);
    setSEIAlco(ingredient.alcohol);
  };

  const handleDeleteClick = (ingredient) => {
    const unId = ingredient.unique_id.split("_");
    const id = unId[1];
    setEditId(id);
    const type = ingredient.type;
       const confirmed = window.confirm(
    `Are you sure you want to delete this ${type}?`
  );

  if (!confirmed) {
    return;
  }
if(type === "ingredient"){
  fetch(`/api/deleteIngredient/${id}`, {
      method: 'DELETE',
      credentials: 'include',
    })
    .then(async response => {
      const data = await response.json();

    if (response.status === 409) {
      const cocktailNames = data.cocktails
        .map(c => c.name)
        .join('\n');

      const confirmed = window.confirm(
        `This ingredient is used in these cocktails:\n\n${cocktailNames}\n\nDeleting it will delete all of these cocktails.\n\nContinue?`
      );

      if (confirmed) {
        fetch(
          `/api/deleteIngredient/${id}?force=true`,
          {
            method: 'DELETE',
            credentials: 'include',
          }
        )
          .then(() => {
            alert(
              'Ingredient and related cocktails deleted successfully.'
            );
            fetchIngredients();
          });
      }

      return;
    }
      fetchIngredients();

      alert('Ingredient deleted successfully');

      // Handle success
    })
    .catch(error => {
      console.error('Error deleting ingredient:', error.message);
      // Handle error
    });
    }else if(type === "juice"){
      fetch(`/api/deleteJuice/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      })
      .then(async response => {
        const data = await response.json();

      if (response.status === 409) {
        const cocktailNames = data.cocktails
          .map(c => c.name)
          .join('\n');

        const confirmed = window.confirm(
          `This juice is used in these cocktails:\n\n${cocktailNames}\n\nDeleting it will delete all of these cocktails.\n\nContinue?`
        );

        if (confirmed) {
          fetch(
            `/api/deleteJuice/${id}?force=true`,
            {
              method: 'DELETE',
              credentials: 'include',
            }
          )
            .then(() => {
              alert(
                'juice and related cocktails deleted successfully.'
              );
              fetchIngredients();
            });
        }

        return;
      }

        fetchIngredients();
        alert('Juice deleted successfully');
      })
      .catch(error => {
        console.error('Error deleting Juice:', error.message);
        alert("An error occurred while deleting juice.");
      });
    }
  
  };
  
  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const filteredIngredients = ingredients.filter((ingredient) =>
    ingredient.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const currentIngredients = filteredIngredients.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredIngredients.length / rowsPerPage);
const pageButtons = [];

let startPage = currentPage - 1;
let endPage = currentPage + 1;

if (currentPage === 1) {
  startPage = 1;
  endPage = Math.min(3, totalPages);
}

if (currentPage === totalPages) {
  startPage = Math.max(1, totalPages - 2);
  endPage = totalPages;
}

for (let i = startPage; i <= endPage; i++) {
  pageButtons.push(
    <button
      key={i}
      onClick={() => paginate(i)}
      className={`pbtn ${
        currentPage === i && smallMedia
          ? "active12a2"
          : currentPage === i
          ? "active12"
          : ""
      }`}
    >
      {i}
    </button>
  );
}
  const indexOfLastRecipe = currentPage * rowsPerPage;
  const indexOfFirstRecipe = indexOfLastRecipe - rowsPerPage;
  const handleNameNew = (event) =>{
    setNewIName(event.target.value);
  }
  const handleCostNew = (event) =>{
  setCstmCost(event.target.value);
  }
  const handleStockNew = (event) =>{
  setNewIStock(event.target.value);
  }
  const handleNameEdit = (event) =>{
    setNEIngredient(event.target.value);
  }
  const handleCostEdit = (event) =>{
    setCstmCost(event.target.value);
  }
  const handleStockEdit = (event) =>{
  setSEIngredient(event.target.value);
  }
  const handleNewSave = () => {
    if(cstmCost === '' || volume === ''){
      alert("all fields are required!");
      return;
    }
      const calculatedCost = Number(cstmCost) / Number(volume);
      
      setNewICost(calculatedCost);

  if (
    !newIName.trim() ||
    !newIStock ||
    !volume ||
    !cstmCost ||
    !macId
  ) {
    alert("All fields are required");
    return;
  }

// Cost cannot be negative
if (Number(newICost) < 0) {
  alert("Cost cannot be negative");
  return;
}

// Stock cannot be negative
if (Number(newIStock) < 0) {
  alert("Stock cannot be negative");
  return;
}

// Alcohol must be between 0 and 100
if (
  newIAlco === '' ||
  newIAlco === null ||
  Number(newIAlco) < 0 ||
  Number(newIAlco) > 100
) {
  alert("Alcohol percentage must be between 0 and 100");
  return;
}

    fetch(`/api/newIngredient`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        name: newIName,
        cost: calculatedCost,
        stockLevel: newIStock,
        volume: Number(volume),
        vol_cost: Number(cstmCost),
        alcohol: newIAlco,
        userId : uId,
        mId: macId
      }),
      credentials: 'include',
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to save new ingredient');
      }
      alert('New ingredient saved successfully');
      setNewIName("");
      setCstmCost("");
      setNewIStock("");
      setNewIngred(false);
      setNewIAlco(0);
      setVolume("");
      setCstmCost("");
      fetchIngredients();
      // Handle success
    })
    .catch(error => {
      console.error('Error saving new ingredient:', error.message);
      // Handle error
    });
  };
  

  const handleSaveChanges = () => {
    if (
      cstmCost === "" ||
      volume === "" ||
      Number(cstmCost) <= 0 ||
      Number(volume) <= 0
    ) {
      alert("Please enter valid volume and cost.");
      return;
    }
    const calculatedCost = Number(cstmCost) / Number(volume);
      setCEIngredient(calculatedCost);
    if(nEIngredient === '' || cEIngredient === '' || sEIngredient === ''){
      alert('All fields are required!');
      return;
    }

    if(typeD === "ingredient"){
        fetch(`/api/updateIngredient/${editId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name: nEIngredient,
            cost: calculatedCost,
            stockLevel: sEIngredient,
            volume: volume,
            vol_cost: cstmCost,
            alcohol: sEIAlco,
            userId: uId
          }),
          credentials: 'include',
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to update ingredient');
          }
          alert('Ingredient updated successfully');
          fetchIngredients();
          setVolume("");
          setCstmCost("");          
          setEditForm(false);
          // Handle success
        })
        .catch(error => {
          console.error('Error updating ingredient:', error.message);
          // Handle error
        });
    }else{
      fetch('/api/updateJuice', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: editId,
          name: nEIngredient,
          cost: calculatedCost,
          stock_level: sEIngredient,
          volume: volume,
          vol_cost: cstmCost,          
          userId: uId
        }),
        credentials: 'include',
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to update juice');
          }
          alert('Juice updated successfully');
          fetchIngredients();
          setVolume("");
          setCstmCost("");
          setEditForm(false);
        })
        .catch(error => {
          console.error('Error updating juice:', error.message);
        });
    }
  };

const paginate = (pageNumber) => {
  setCurrentPage(pageNumber);

  requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
};
  // new task
  const toggleJuice = () =>{
    setJuices(true);
    if(recipeMainImages.length !== 0){
      fetchImage(recipeMainImages[0].name);
    }
  } 
  const toggleing = () =>{
    setJuices(false);
  } 
  const handleRatio = (event) => {
    setCurrentR(event.target.value);}
  const handleNewJuice = () =>{
    const flavour = currentR.split("/")[0];
    const water = currentR.split("/")[1];
      const calculatedCost = Number(cstmCost) / Number(volume);
      setNewICost(calculatedCost);
    if(currentR === '' || newIStock === '' || !calculatedCost || newIName === '' || newSell === '' 
      || newIqtyt.trim() === ''|| img.trim() === ''|| macId === null){
      alert('All fields are required!');
        if (!volume || !cstmCost
          ) {
            alert("volume and cost are rquired");
          }
      return;
    }else{
       
      fetch(`/api/newJuice`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: newIName,
          cost: calculatedCost,
          stockLevel: newIStock,
          volume: Number(volume),
          vol_cost: Number(cstmCost),
          water:water,
          flavour: flavour,
          newSell: newSell,
          qunty: newIqtyt,
          img: img,
          mId: macId,
          userId: uId
        }),
        credentials: 'include',
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to post juice');
        }
        alert("Juice Added Successfully. Make sure it's added to a pump");
        fetchIngredients();
        setEditForm(false);
        setNewIngred(false);
        setCurrentR("");
        setNewIStock('');
        setNewICost('');
        setVolume("");
        setCstmCost("");
        // setNewIName("");
        setNewSell("");
        setNewIqtyt("");
        setMacName("");
        setImg("");
        fetchImage(recipeMainImages[0].name);
      })
      .catch(error => {
        console.error('Error updating ingredient:', error.message);
        // Handle error
      });
    }

  }
  const handleCancelEdit = () => {
    setEditForm(false);
    setNewIngred(false);
    setCurrentR("");
    setNewIStock('');
    setNewICost('');
    setCstmCost("");
    setVolume("");
    setNewIName("");
    setNewSell("");
    setNewIqtyt("");
    setMacName("");
    setImg("");
   // setImageName(image35);
  };
  const handleNSell = (event) =>{
    setNewSell(event.target.value);
  } 
  const handleQty = (event) =>{
    setNewIqtyt(event.target.value);
  }
  const fetchMachines = async () => {
    try {
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      if (!userData || !userData.id) {
        throw new Error('User ID not found in session storage');
      }
  
      const userId = userData.id;
      const response = await axios.get(`/api/machines?userId=${userId}`,
        { withCredentials: true }
      );
      
          const machines = response.data;
      setMachines(machines);
      
    } catch (error) {
      console.error('Error fetching machines:', error);
    }
  };
  const handleMId = (machine) =>{
    if(machine.name || machine.id){
      setMacName(machine.name);
      setMacId(machine.id);
    }else{
      alert(machine);
    }

  }
  const currentImage = (selected) =>{
    fetchImage3(selected.name);
    setImg(""+selected.name+"");
    setShowDrop(false);
  }
  const showContainer = () =>{
    setShowDrop(!showDrop);
  }
  const heightStyle = () => {
    const diff = Math.min(indexOfLastRecipe, filteredIngredients.length) - indexOfFirstRecipe;
    
    if (diff < 5) {
      return `${diff * 12.2}%`;  // First condition: when diff is less than 5
    } else if (diff < 10) {
      return `${diff * 8}%`;   // Second condition: when diff is less than 10
    } else {
      return '';               // Default case: no specific height applied
    }
  };


const [hoveredIndex, setHoveredIndex] = useState(null);
      const [supAdmin, setSupAdmin] = useState(false);
      useEffect(() => {
        const userDataString = sessionStorage.getItem('userData');
        const supperAdminData = sessionStorage.getItem('super');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setUserD(userData);
        }
        if(supperAdminData === 'true'){ 
          setSupAdmin(true);   
        }
        
    }, []);
    useEffect(() => {
        setMachineId(userD ?.selectedMachineIds);
    }, [userD]);

  useEffect(() => {
  const totalPages = Math.ceil(
    filteredIngredients.length / rowsPerPage
  );

  if (currentPage > totalPages) {
    setCurrentPage(
      totalPages > 0 ? totalPages : 1
    );
  }
}, [
  filteredIngredients.length,
  currentPage,
  rowsPerPage
]);
const handleUploadImageClick = () => {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "image/jpeg,image/png,image/jpg,image/webp";

  fileInput.onchange = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    // optional client-side size check (2MB)
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/webp"
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, and WEBP images are allowed");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      alert("Image must be less than 5MB");
      return;
    }

    uploadImage(file);
  };

  fileInput.click();
};

  const fetchRecImages = async () => {
       
    try {
      const response = await fetch('/api/getRecImages', {
        credentials: 'include',
      });
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error('Network response was not ok: ' + errorMessage);
      }
      const data = await response.json();
      setRecipeMainImages(data);
      fetchImages2(data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const fetchImages2 = async (imagesLoop) => {
   
    let urls = {};
    for (let img of imagesLoop) {
      try {
        const res = await axios.get(
          `/api/image-base?image-name=${img.name}`,
          {
            withCredentials: true,
            responseType: 'blob',
          }
        );
        const imageUrl = URL.createObjectURL(res.data);
        urls[img.name] = imageUrl;
      } catch (err) {
        console.error("Error fetching image:", err);
      }
    }
    setImageUrls(urls);
  };



  const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

    try {
      const response =
      await fetch(
        "/api/upload-recipe-image",

        {

          method:
            "POST",

          credentials:
            "include",

          headers: {

            "x-file-name":
              file.name

          },

          body:
            formData

        }
      );
    if (response.ok) {
      console.log("Image uploaded successfully");
      fetchRecImages(); // Refresh the image list after upload
    } else {
      const data =
      await response.json();

    alert(
      data.message
    );
    }
  } catch (error) {
    console.error("Error during image upload:", error);
  }
};


    // Utility function to remove the file extension
    const removeFileExtension = (filename) => {
      return filename.replace(/\.[^/.]+$/, '');
    };

const renderRecipeImages = () => {

  if (recipeMainImages.length === 0) {

    if (supAdmin === true) {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          <button
            className="upload-img-button"
            onClick={handleUploadImageClick}
          >
            Upload Image
          </button>
        </>
      );
    }

    return <div className='no-img-div'>No images available</div>;
  } else {

    // Filter images by search text
    const filteredRecipeImages = recipeMainImages.filter((image) =>
      removeFileExtension(image.name)
        .toLowerCase()
        .includes(imageSearch.toLowerCase())
    );

    // Sort filtered images
    const sortedRecipeImages = [...filteredRecipeImages].sort(
      (a, b) =>
        a.name.localeCompare(
          b.name,
          undefined,
          { sensitivity: "base" }
        )
    );

    if (supAdmin === true) {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          {sortedRecipeImages.map((image, index) => (
            <div
              key={index}
              className="recipe-image-item image-item-juice"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="ju-l-img">
                <img
                  src={imageUrls[image.name]}
                  alt={`Recipe Image ${index}`}
                  onClick={() => currentImage(image)}
                  className={`${smallMedia ? "loop-images-2" : "loop-images-juice"}`}
                />
              </div>

              <p className='loop-image-names'>
                {removeFileExtension(image.name)}
              </p>

              {hoveredIndex === index && (
                <div className="overlay-buttons">
                  <button
                    className="select-button"
                    onClick={() => handleSelectImageR(image)}
                  >
                    Select
                  </button>

                  <button
                    className="delete-button"
                    onClick={() => handleDeleteImageR(image.id)}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          ))}

          {supAdmin && (
            <button
              className="upload-img-button"
              onClick={handleUploadImageClick}
            >
              Upload Image
            </button>
          )}
        </>
      );
    } else {
      return (
        <>
          <div className="image-search-container">
            <input
              type="text"
              placeholder="Search images..."
              value={imageSearch}
              onChange={(e) => setImageSearch(e.target.value)}
              className="image-search-input"
            />
          </div>

          {sortedRecipeImages.map((image, index) => (
            <div
              key={index}
              className="recipe-image-item image-item-juice"
              onClick={() => currentImage(image)}
            >
              <div className="ju-l-img">
                <img
                  src={imageUrls[image.name]}
                  alt={`Recipe Image ${index}`}
                  className={`${smallMedia ? "loop-images-2" : "loop-images-juice"}`}
                />
              </div>

              <p className='loop-image-names'>
                {removeFileExtension(image.name)}
              </p>
            </div>
          ))}
        </>
      );
    }
  }
};

  // Handle select and delete actions
const handleSelectImageR = (image) => {
  if (recipeMainImages && recipeMainImages.length > 0) {
    const imageName = image.name;
    // Assuming the images are inside the 'img/image' directory
    fetchImage(imageName);
    const clrName = removeFileExtension(imageName);
    setImageName(clrName);
  }
  
};
const handleDeleteImageR = async (id) => {
  const isConfirmed = window.confirm("Are you sure you want to delete this image?");
   
  if (isConfirmed) {
    try {
      const response = await fetch(`/api/delete-recipe-image/${id}`, {
        method: 'DELETE',
        credentials: 'include',
      });
      // alert(response);
      if (response.ok) {
        console.log("Image deleted successfully");

        setRecipeMainImages(prevImages => {
          const updatedImages = prevImages.filter(image => image.id !== id);

         return updatedImages;
        });
        
      } else {
        const errorData = await response.json();
        console.error("Failed to delete image:", errorData.message || "Unknown error");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  } else {
    console.log("Image deletion canceled");
  }
};

  return (
    <>
    <div className="sp-recipes">
      <div className="recipe-left" style={{display: smallMedia ? "none" : "block"}} ></div>
      <div className="full-details">
      <div className={` ${smallMedia ? "details2a" : "details2 topDiv"}`}>
      <div className={` same select-sp ${smallMedia ? "same2 display2" : ""}`}>
          <div>
          Show
          </div>
          <div className={`main-Select ${smallMedia ? "sub-class2 main-Select2" : ""}`}>
        <select value={rowsPerPage} onChange={handleRowsPerPageChange} className={`select-container ${smallMedia ? "select-container2" : ""}`}>
          {[5, 10, 15, 20, 25, 30].map((value) => (
            <option  className='options' key={value} value={value}>
              {value}
            </option>
          ))}
        </select>
        </div>
        <div>
        Entries
        </div>
          </div>
          <div className={` same ${smallMedia ? "same2" : ""}`}>
            <div className={` same ${smallMedia ? "search-container2" : "search-container"}`}>
              <div className='triangle-container-sea'></div>
              <div
              className={`${smallMedia ? "shadeTriangle-sea2" : "shadeTriangle-sea"}`}
              ></div>
        <input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearch}
          className={` search-input ${smallMedia ? "search-input2" : ""}`}
        />
      <span className={` ${smallMedia ? "search-icon2" : "search-icon"}`} style={{ display: showIcon ? "block" : "none"}}>
          <SearchIcon className="sp-icon" />
        </span>
      </div>
        </div>
        <div className={` same btn-add ${smallMedia ? "same2" : ""}`}> 
            <button onClick={() => setNewIngred(true)} className='btnAdd'>
            <div className={` ${smallMedia ? "shadeTriangle-adbnt2" : "shadeTriangle-adbnt"}`}></div>
              <div className="btn-both">
                <div className='icon'>
                <Plus className="sp-icon"/>
                </div>
                <span className="add-text">Add New </span>
              </div>
            </button>
          </div>
      </div>
      <div className="popup-main" style={{display: editFrom ? "block" : "none"}}>
      <div className={`${smallMedia ? "popup2" : " popEI2 popup ingEPopup"}`} >
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`}></div>
          </div>
          {/* Popup content for Edit ingredient */}
          <div className="form-pump">
            <h2 className='headIngre'>Edit Ingredient</h2>
            <div className="inpt-cont inpt-cont-i">
              <label>Name:</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={nEIngredient}
                  onChange={handleNameEdit}
                  className="pop-inpt"
                />
                <div className="inptC"></div>
              </div>
            </div>
            <div className="inpt-cont inpt-cont-i">
              <label><span>Cost Per </span> 
              <select
                value={volume}
                onChange={(e) => setVolume(Number(e.target.value))}
                className="cstmVolume"
              >
                <option value="">Select Volume</option>
                {volumeOptions.map((v) => (
                  <option key={v} value={v}>
                    {v} ml
                  </option>
                ))}
              </select>
              <span> (ml):</span></label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={cstmCost}
                  onChange={handleCostEdit}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div 
             className="inpt-cont inpt-cont-i"
             style={{display: edtIngTyp === "juice" ? 'block' : 'none'}}>
              <label>Stock Level (Pouches):</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={sEIngredient}
                  onChange={handleStockEdit}
                  className="pop-inpt"
                />
              <div className="inptC"></div>

              </div>
            </div>
            <div 
            className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus cstm-mrgn"
            style={{display: edtIngTyp === "juice" ? 'none' : 'flex'}}>
              <div className="inptS">
                <label>Stock Level (Pouches):</label>
                <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
                <div className="inptO"></div>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={sEIngredient}
                    onChange={handleStockEdit}
                    className="pop-inpt"
                  />
                <div className="inptC"></div>
                </div>
              </div>
              <div className="inptS">
                <label>Alcohol Percentage:</label>
                <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
                <div className="inptO"></div>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={sEIAlco}
                    onChange={(e) => setSEIAlco(e.target.value)}
                    className="pop-inpt"
                  />
                <div className="inptC"></div>
                </div>
              </div>
            </div>
            <div className="pop-btn-sec">
            <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
                  Close
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2"}`}>
                <button onClick={handleSaveChanges} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon">
                <SIcon className='sp-icon' />
              </div>
                <div>
                Save Change
                </div> 
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className={`${smallMedia ? "popup2" : " popEI2 popup ingEPopup"}`} style={{display: newIngred ? "block" : "none"}}>
        <div className='triangle-container-pop'>
          <div className={`${smallMedia ? "shadeTriangle-pop" : " shadeTriangle-pop2"}`} ></div>
          </div>
          <h2 className='headIngre ingreH2'><div className="subHead" onClick={toggleing} style={{zIndex: 1, backgroundColor: juices ? 'transparent' : '#EF7C32'}} >Ingredient</div>
          <div className="subHead" onClick={toggleJuice} style={{zIndex: 1,  backgroundColor: juices ? '#EF7C32' : 'transparent'}}>Juice</div></h2>
          {/* Popup content for adding new ingredient */}
          <div className="form-pump" style={{display: juices ? 'none' : 'block'}}>
            <div className="inpt-cont inpt-cont-i">
              <label>Name:</label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={newIName}
                  onChange={handleNameNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>

            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus cstm-mrgn">
            <div className="inptS">
            <label><span>Cost Per </span> 
              <select
                value={volume}
                onChange={(e) => setVolume(Number(e.target.value))}
                className="cstmVolume"
              >
                <option value="">Select Volume</option>
                {volumeOptions.map((v) => (
                  <option key={v} value={v}>
                    {v} ml
                  </option>
                ))}
              </select>
              <span> (ml):</span></label>
              <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
              <div className="inptO"></div>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={cstmCost}
                  onChange={handleCostNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inptS">
            <label> Machine Name: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
            <select value={macName}   onChange={(e) => {
                  const selectedMachine = machines.find(Machine => Machine.name === e.target.value);
                  handleMId(selectedMachine != null ? selectedMachine : "Choose Correct option.");
                }} className="pop-inpt macName">
                  <option className='options'>--Choose Machine--</option>
                  {machines.map((machine) => (
                    <option className='options' key={machine.id} id={machine.id} value={machine.name}>
                      {machine.name}
                    </option>
                  ))}
                </select>
            <div className="inptC"></div>
            </div>
            </div>
            </div>


            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus cstm-mrgn">
              <div className="inptS">
                <label>Stock Level (Pouches):</label>
                <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
                <div className="inptO"></div>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={newIStock}
                    onChange={handleStockNew}
                    className="pop-inpt"
                  />
                <div className="inptC"></div>
                </div>
              </div>
              <div className="inptS">
                <label>Alcohol Percentage:</label>
                <div className={`inpt ${smallMedia ? "" : " inpt2 inpt2-i"}`}>
                <div className="inptO"></div>
                  <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={newIAlco}
                    onChange={(e) => setNewIAlco(e.target.value)}
                    className="pop-inpt"
                  />
                <div className="inptC"></div>
                </div>
              </div>
            </div>
            <div className="pop-btn-sec">
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
              <div>
              Close
              </div>
                  
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 "}`}>
                <button onClick={handleNewSave} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  Save
                </div>
                </button>
              </div>
            </div>
          </div>
                                      {/* Juice */}
          <div className="form-pump" style={{display: juices ? 'block' : 'none'}}>
          <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
          <div className="inptS">
              <label>Name:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <input
                  type="text"
                  value={newIName}
                  onChange={handleNameNew}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
            <div className="inptS">
              <label>Quantaty:</label>
              <div className='inpt inpt2 inpt2-i'>
              <div className="inptO"></div>
                <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={newIqtyt}
                  onChange={handleQty}
                  className="pop-inpt"
                />
              <div className="inptC"></div>
              </div>
            </div>
          </div>

            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
            <div className="inptS">
            <label><span>Cost Per </span> 
              <select
                value={volume}
                onChange={(e) => setVolume(Number(e.target.value))}
                className="cstmVolume"
              >
                <option value="">Select Volume</option>
                {volumeOptions.map((v) => (
                  <option key={v} value={v}>
                    {v} ml
                  </option>
                ))}
              </select>
              <span> (ml):</span></label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <input
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    value={cstmCost}
                    onChange={handleCostNew}
                  className="pop-inpt new-file"
                />
            <div className="inptC"></div>
            </div>
            </div>
            <div className="inptS">
            <label> Stock Level (Pouches): </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
            <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={newIStock}
                  onChange={handleStockNew}
                  className="pop-inpt"
                />
            <div className="inptC"></div>
            </div>
            </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus">
            <div className="inptS">
            <label> Selling Price: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
            <input
                  type="number"
                  onWheel={(e) => e.target.blur()}
                  value={newSell}
                  onChange={handleNSell}
                  className="pop-inpt"
                />
            <div className="inptC"></div>
            </div>
            </div>
            <div className="inptS">
            <label> Ratio: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
                <select
                    name="Ratio"
                    value={currentR}
                    onChange={handleRatio}
                  className="pop-inpt myselect">
                  <option className='options'>Choose Ratio</option>
                  <option className="options" value={"1/1"}>1/1</option>
                  <option className="options" value={"1/5"}>1/5</option>
                  <option className="options" value={"1/20"}>1/20</option>
                  <option className="options" value={"1/50"}>1/50</option>
                </select>
            <div className="inptC"></div>
            </div>
            </div>
            </div>
            <div className="inpt-cont inpt-cont-i inpt-cont-mac spec-aus cstm-mrgn">
            <div className="inptS">
            <label> image:</label> 
            <div className="myopt" onClick={showContainer}>
            <div  className={` ${smallMedia ? "selectImage-2" : "selectImage jImage"}`}>
              <div className={` ${smallMedia ? "shadeTriangle-image-2" : "shadeTriangle-image"}`}></div>
            <img src={selectedImage} alt={selectedImage+" small selected image"}  className="drop-image drop2Img" />
            </div>
            </div>
            <div className={` ${smallMedia ? "drop-imge-2" : "drop-imge jDImg"}`} style={{display: showDrop ? "block": "none"}}>
            {renderRecipeImages()}
          </div>
            
            </div>
            <div className="inptS">
            <label> Machine Name: </label>
            <div className='inpt inpt2 inpt2-i'>
            <div className="inptO"></div>
            <select value={macName}   onChange={(e) => {
                  const selectedMachine = machines.find(Machine => Machine.name === e.target.value);
                  handleMId(selectedMachine != null ? selectedMachine : "Choose Correct option.");
                }} className="pop-inpt macName">
                  <option className='options'>--Choose Machine--</option>
                  {machines.map((machine) => (
                    <option className='options' key={machine.id} id={machine.id} value={machine.name}>
                      {machine.name}
                    </option>
                  ))}
                </select>
            <div className="inptC"></div>
            </div>
            </div>
            </div>
            <div className="pop-btn-sec btns-juices">
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 btn266"}`}>
                <button onClick={handleCancelEdit} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="canIcon">
                <ClIcon className='sp-icon' />
              </div>
              <div>
              Close
              </div>
                  
                </button>
              </div>
              <div className={`${smallMedia ? "pop-btn" : " pop-btn2 "}`}>
                <button onClick={handleNewJuice} className={`${smallMedia ? "btn-p" : " btn-p2"}`}>
                <div className='triangle-container-popbtn'>
                <div className={`${smallMedia ? "shadeTriangle-popbtn" : " shadeTriangle-popbtn2"}`}></div>
              </div>
              <div className="svIcon-n">
                <SIcon className='sp-icon' />
              </div>
                <div>
                  Save
                </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      {/* Second div */}
      <div className="my-table ing-tbl" style={{ height: heightStyle()}}>
        <table className="customTable"  style={{borderCollapse: "separate", borderSpacing: "0 0.911vh"}}>
          <thead className="tb-head borderRow ing-th">
            <tr className="my-row">
              <th className='na-sp-t'>
              <div className='left-tr-name' style={{display : smallMedia ? 'none' : 'block'}}></div>
              <div className="nm-class">
              Name
              </div>
              </th>
              <th className="nd-td">Cost (ml)</th>
              <th>Holding Stocks</th>
              <th>Machine Stock</th>
              <th>Total Stock (ml)</th>
              <th className='sp-td sp-tr spp'>
              <div className="ac-class">
              Action
              </div>
            <div className='right-tr-action' style={{display : smallMedia ? 'none' : 'block'}}></div>
               </th>
            </tr>
          
          </thead>
          <tbody className="cu-body">
            {(searchTerm === ''?currentIngredients:filteredIngredients).map((ingredient) => (
              <tr key={ingredient.unique_id} className="custom-row">
                <td className="first-td">{ingredient.name}</td>
                <td className="second-td">{Number(ingredient.cost_ml).toFixed(3)}</td>
                <td className="third-td">
                  {(Number(ingredient.stock_level_ml) + Number(ingredient.pump_level) / 1000) < 0 
                    ? 0 
                    : (Number(ingredient.stock_level_ml) + Number(ingredient.pump_level) / 1000).toFixed(3)}
                </td>
                <td className="mStock">{ingredient.available === 1 ? ingredient.pump_level : 'N/A'}</td>
                <td className="tStock">
                {(ingredient.stock_level_ml * 1000 + ingredient.pump_level) < 0 
                  ? 0 
                  : (ingredient.stock_level_ml * 1000 + ingredient.pump_level)}
              </td>
                <td className="last-td rad2">
                <div className="flex-container">
                <button onClick={() => handleEditClick(ingredient)}
                className={`editconst  ${smallMedia ? "editconst2" : "ed-sp in-edbtn"}`}
                >
                    <div className={` ${smallMedia ? "shadeTriangle-idbnt2" : "shadeTriangle-idbnt"}`}></div>
                  <div className="inE-icon icon22" style={{display : smallMedia ? 'none' : 'block'}}>
                  <Edit className='sp-icon' />
                  </div>
                  <div>
                  Edit
                  </div>
                </button>
                <button onClick={() => handleDeleteClick(ingredient)}
                className={`deleteconst ${smallMedia ? "deleteconst2" : " in-debtn sp-margin"}`}
                >
                <div className={` ${smallMedia ? "shadeTriangle-idbntD2" : "shadeTriangle-idbntD"}`}></div>
                  <div className="inD-icon icon22" style={{display : smallMedia ? 'none' : 'block'}}>
                  <Delete className='sp-icon'/>
                  </div>
                  <div>
                  Delete
                  </div>
                </button>
                </div>
                
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Third div */}
      <div className='bothDiv' >
      <div className='bottomSh'>
          <div className='results'>
            Showing {startIndex + 1} to {endIndex}
          </div>
          <div className='whiteClass'>
            (Total {totalRows} entries)
          </div>
        </div>
          
      <div className="pagination-info">
      <button onClick={() => paginate(currentPage - 1)} className='constbtn' disabled={currentPage === 1}>Previous</button>
        {pageButtons}
        <button onClick={() => paginate(currentPage + 1)} className='constbtn' disabled={currentPage === totalPages}>Next</button>
      </div>
      </div>
      </div>
    <div className="recipe-right" style={{display: smallMedia ? "none" : "block"}}></div>
    </div>
  </>
  );
};

export default PaginationTable;
